const translations = {
  "en": {
    "Asset": "Asset",
    "Asset types": "Asset types",
    "History": "History"
  },
  "zh-tw": {
    "Asset": "資產",
    "Asset types": "資產類型",
    "History": "歷史紀錄"
  }
};

export default translations;
